import React from 'react';
import { Clock, Users, CalendarDays, TrendingDown } from 'lucide-react';

const Urgency: React.FC = () => {
  return (
    <section className="py-24 bg-[#4E3629]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Capacity Scarcity */}
          <div className="bg-white/5 backdrop-blur-md p-10 rounded-[2rem] border-2 border-white/10 text-white shadow-xl relative overflow-hidden group hover:border-[#FF6B35]/50 transition-colors">
            <Users className="w-12 h-12 text-[#FF6B35] mb-6 group-hover:scale-110 transition-transform" />
            <h3 className="text-2xl font-black mb-4 uppercase italic">Onboarding Limit</h3>
            <p className="text-white/80 font-bold mb-8 leading-relaxed">
              To ensure every new partner gets their system set up perfectly, we only take on <span className="text-white font-black underline decoration-[#FF6B35]">10 new tree pros per month.</span>
            </p>
            <div className="bg-[#1A4D2E] rounded-xl p-5 border border-white/10 shadow-lg">
              <p className="text-[10px] font-black uppercase opacity-60 tracking-widest mb-1 text-[#F4E4C1]">Monthly Intake Status</p>
              <p className="text-xl font-black text-white italic">3 of 10 spots remaining</p>
            </div>
          </div>

          {/* Seasonal Urgency */}
          <div className="bg-white/5 backdrop-blur-md p-10 rounded-[2rem] border-2 border-white/10 text-white shadow-xl relative overflow-hidden group hover:border-[#FF6B35]/50 transition-colors">
            <CalendarDays className="w-12 h-12 text-[#1A4D2E] mb-6 group-hover:scale-110 transition-transform" />
            <h3 className="text-2xl font-black mb-4 uppercase italic">Spring Rush Prep</h3>
            <p className="text-white/80 font-bold mb-8 leading-relaxed">
              Setup takes 14 days. If you wait until you're busy to fix your sales, you've already lost the biggest quarter of the year. 
            </p>
            <div className="text-sm font-black text-[#1A4D2E] bg-[#F4E4C1] px-5 py-3 rounded-xl inline-block uppercase tracking-tight shadow-lg">
              Best time to build is BEFORE the storm.
            </div>
          </div>

          {/* Opportunity Cost */}
          <div className="bg-white/5 backdrop-blur-md p-10 rounded-[2rem] border-2 border-white/10 text-white shadow-xl relative overflow-hidden group hover:border-[#FF6B35]/50 transition-colors">
            <TrendingDown className="w-12 h-12 text-[#FF6B35] mb-6 group-hover:scale-110 transition-transform" />
            <h3 className="text-2xl font-black mb-4 uppercase italic">The "Delay Tax"</h3>
            <p className="text-white/80 font-bold mb-8 leading-relaxed">
              The average tree service misses <span className="text-white font-black underline decoration-[#FF6B35]">$2,400 in potential jobs every week</span> due to slow follow-up.
            </p>
            <div className="text-center bg-red-600/20 border-2 border-red-500/30 p-6 rounded-xl shadow-lg">
              <p className="text-[10px] font-black uppercase opacity-60 tracking-widest mb-1 text-red-100">Daily Revenue Leakage</p>
              <p className="text-3xl font-black text-white italic">$342 / DAY LOST</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Urgency;